import { Component, OnInit } from '@angular/core';
import { label } from 'src/app/constants/labels';
import { AuthenticationService } from 'src/app/core/authentication/authentication.service';

@Component({
  selector: 'app-sp-tabbar',
  templateUrl: './sp-tabbar.component.html',
  styleUrls: ['./sp-tabbar.component.scss']
})
export class SpTabbarComponent implements OnInit {

  labels;
  isAdmin;

  constructor(private readonly authenticationService: AuthenticationService) { }
   /**
   * intilize the tabBar component
   */
  ngOnInit() {
    this.isAdmin = this.authenticationService.adminRole;
    this.labels = label;
  }

}
